<!-- 聚会页面 提交聚会信息 调转至预约成功页面 -->
<template>
  <div class="appointmentSuccDiv">
    <div class="appointmentSucc">
      <img
        src="../../assets/image/btn_yuyuechenggong_nor.png"
        alt="背景图片"
        class="appointmentSuccImg"
      />
      <div class="succIconImgDiv">
        <img
          src="../../assets/image/btn_chenggong_nor.png"
          alt="成功图片"
          class="succIconImg"
        />
      </div>
      <div class="succTitle">预约成功</div>
      <div class="succTip">我们会在三个工作日内联系您，沟通具体返校事宜</div>
      <div class="succTips">请保持电话畅通</div>
      <div class="phone">返校服务热线：13591668838</div>
      <div class="btnDIv"><button class="btn" @click="back">返 回</button></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    back() {
      // return this.$router.back();
      return this.$router.go(-2);
    },
  },
};
</script>
<style lang="less" scoped>
.appointmentSuccDiv {
  position: relative;
  // min-height: 100vh;
  .appointmentSucc {
    position: relative;
    left: 5%;
    top: 15px;
    width: 90%;
    height: 90%;
    .appointmentSuccImg {
      width: 100%;
      height: 100%;
    }
    .succIconImgDiv {
      position: absolute;
      top: 10%;
      left: 50%;
      transform: translateX(-50%);
      width: 20%;
      .succIconImg {
        width: 100%;
      }
    }
    .succTitle {
      position: absolute;
      top: 25%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 1.5rem;
      font-weight: bold;
      color: #333333;
    }
    .succTip {
      position: absolute;
      top: 33%;
      left: 50%;
      text-align: center;
      width: 100%;
      transform: translateX(-50%);
      font-size: 1.1rem;
      font-weight: bold;
      color: #333333;
      white-space: nowrap;
    }
    .succTips {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 1.1rem;
      font-weight: bold;
      color: #333333;
    }
    .phone {
      position: absolute;
      top: 47%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 1.2rem;
      font-weight: bold;
      color: #333333;
      white-space: nowrap;
    }
    .btnDIv {
      position: absolute;
      top: 80%;
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
    }
    .btn {
      width: 100%;
      background: linear-gradient(270deg, #00706E, #00706E);
      border: 0;
      font-size: 1.3rem;
      border-radius: 30px;
      font-weight: bold;
      color: white;
      padding: 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backSchool/AppointmentSucc.vue